import { render, staticRenderFns } from "./comp_profile.vue?vue&type=template&id=7cd5f09c&scoped=true"
import script from "./comp_profile.vue?vue&type=script&lang=js"
export * from "./comp_profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd5f09c",
  null
  
)

export default component.exports